import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Building2, Loader2 } from "lucide-react";
import api from "../lib/api";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { RequestForm } from "../components/institution/RequestForm";
import { OrgOverview } from "../components/institution/OrgOverview";
import { OrgQuotes } from "../components/institution/OrgQuotes";
import { OrgBilling } from "../components/institution/OrgBilling";
import { OrgTeam } from "../components/institution/OrgTeam";
import { MessagesPanel } from "../components/institution/MessagesPanel";
import { Pill } from "../components/institution/ui";

const TABS = [["overview", "Overview"], ["quotes", "Quotations"], ["billing", "Billing"], ["team", "Dentists & licenses"], ["messages", "Messages"]];

export default function Organization() {
  const [org, setOrg] = useState(undefined);
  const [params, setParams] = useSearchParams();
  const load = () => api.get("/org").then(({ data }) => setOrg(data.organization)).catch(() => setOrg(null));
  useEffect(() => { load(); }, []);
  if (org === undefined) return <Loader2 className="w-6 h-6 animate-spin text-slate-400" />;
  if (!org) {
    return (
      <div className="max-w-3xl" data-testid="org-page-empty">
        <h1 className="font-heading text-2xl sm:text-3xl font-bold text-slate-900 flex items-center gap-2"><Building2 className="w-7 h-7 text-[#1C6FE3]" /> Clinics & Organizations</h1>
        <p className="text-slate-500 mt-1 mb-6">Empower your dental team with evidence-based clinical decision support. Submit a request and receive a custom quotation.</p>
        <RequestForm onDone={load} />
      </div>
    );
  }
  const tab = params.get("tab") || "overview";
  return (
    <div data-testid="org-page">
      <div className="flex flex-wrap items-center gap-3">
        <h1 className="font-heading text-2xl sm:text-3xl font-bold text-slate-900" data-testid="org-name">{org.name}</h1>
        <Pill s={org.status} testid="org-status" />
      </div>
      <p className="text-slate-500 mt-1">Organization dashboard — licenses, quotations, billing and renewals.</p>
      <Tabs value={tab} onValueChange={(v) => setParams({ tab: v })} className="mt-6">
        <TabsList className="flex-wrap h-auto">
          {TABS.map(([id, label]) => (
            <TabsTrigger key={id} value={id} data-testid={`org-tab-${id}`}>{label}{id === "messages" && org.unread > 0 ? ` (${org.unread})` : ""}</TabsTrigger>
          ))}
        </TabsList>
        <TabsContent value="overview" className="mt-5"><OrgOverview org={org} /></TabsContent>
        <TabsContent value="quotes" className="mt-5"><OrgQuotes org={org} onUpdated={setOrg} /></TabsContent>
        <TabsContent value="billing" className="mt-5"><OrgBilling org={org} onUpdated={setOrg} /></TabsContent>
        <TabsContent value="team" className="mt-5"><OrgTeam org={org} onUpdated={setOrg} /></TabsContent>
        <TabsContent value="messages" className="mt-5"><MessagesPanel base="/org/messages" side="org" title="Messages with DentiCision" /></TabsContent>
      </Tabs>
    </div>
  );
}
